import { useEffect, useState } from 'react';
import { useGetDownloadNaechsterWerktagMutation, useGetDownloadVonBisMutation } from '../../api/AuftragAPI';
import { useGetUserProfilesMutation } from '../../api/UserRoleAPI';
import { IOnlyUserProfile } from '../../types/Types';
import { formatToEuroDate, formatToStringISODate } from '../../util/DateUtils';
import { LoadingModal } from '../LoadingModal/LoadingModal';

interface ThisProps {
  //uidAuftrag: string;
}

/**
 * @author noone
 */
const ButtonGetSicherungsdateienComponent: React.FC<ThisProps> = (props) => {

  const [getUserProfilesAPI] = useGetUserProfilesMutation();
  const [getDlMutation] = useGetDownloadNaechsterWerktagMutation();
  const [getDownloadVonBisAPI] = useGetDownloadVonBisMutation();

  const [naechsterWerktag, setNaechsterWerktag] = useState<Date>(new Date());
  const [downloadTag, setDownloadTag] = useState<Date>(new Date());
  const [inEinerWoche, setInEinerWoche] = useState<Date>(new Date());
  const [ausfuehrenderUid, setAusfuehrenderUid] = useState<string | undefined>();
  const [userProfiles, setUserProfiles] = useState<IOnlyUserProfile[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);


  const downloadFilesNextWorkday = async () => {
    setIsLoading(true);
    const { blob, filename } = 
      await getDlMutation({ datum: downloadTag, ausfuehrenderUid: ausfuehrenderUid })
      .unwrap()
      .finally(() => setIsLoading(false))
      ;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  const downloadFilesVonBis = async () => {
    setIsLoading(true);
    const { blob, filename } =
      await getDownloadVonBisAPI({ von: naechsterWerktag, bis: inEinerWoche, ausfuehrenderUid: undefined })
        .unwrap()
        .finally(() => setIsLoading(false))
      ;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  const ermitteleNaechstenWerktag = () => {
    let naechsterTag = new Date();
    naechsterTag.setDate(naechsterTag.getDate() + 1);
    if (naechsterTag.getDay() === 6) { // Samstag
      naechsterTag.setDate(naechsterTag.getDate() + 2); // Montag
    } else if (naechsterTag.getDay() === 7) { // Sonntag
      naechsterTag.setDate(naechsterTag.getDate() + 1); // Montag
    }
    setNaechsterWerktag(naechsterTag);
  }

  const ermitteleInEinerWoche = () => {
    let inEinerWoche = new Date();
    inEinerWoche.setDate(inEinerWoche.getDate() + 7);
    /*if (naechsterTag.getDay() === 6) { // Samstag
        naechsterTag.setDate(naechsterTag.getDate() + 2); // Montag
    } else if (naechsterTag.getDay() === 7) { // Sonntag
        naechsterTag.setDate(naechsterTag.getDate() + 1); // Montag
    }*/
    setInEinerWoche(inEinerWoche);
  }

  useEffect(() => {
    ermitteleNaechstenWerktag();
    ermitteleInEinerWoche();

    //
    getUserProfilesAPI().unwrap()
      .then(data => {
        setUserProfiles(data);
      });
  }, []);


  return (
    <>
      <div className="input-group mb-1">

        <LoadingModal show={isLoading} />

        <select className="custom-select" name="selectAusfuehrender" id="selectAusfuehrender" value={ausfuehrenderUid} onChange={(e) => { setAusfuehrenderUid(e.target.value) }} >
          <option value={""}>--- Bitte auswählen ---</option>
          {userProfiles.map((user, index) => {
            return <option key={index} value={user.uid}>{user.name}</option>;
          })}
        </select>
        <div className="input-group-append">
          <input type="date" value={formatToStringISODate(downloadTag)} onChange={(e) => setDownloadTag(new Date(e.target.value))} />
          <button className="btn btn-primary" onClick={downloadFilesNextWorkday}><i className="bi bi-download"></i> Download Dateien</button>
        </div>
      </div>

      <button className="btn btn-secondary" onClick={downloadFilesVonBis}><i className="bi bi-download"></i> Download Dateien für {formatToEuroDate(inEinerWoche)} (Sicherung)</button>

    </>
  );

}

export default ButtonGetSicherungsdateienComponent;